import { getApi, postApi } from "../utils/apiHelper";
import Cookies from 'js-cookie';

// User login
export const loginUser = (credentials) => {
  return postApi('/auth/jwt/login/', credentials);
};

export const googleLoginUser = (credentials) => {
  return postApi('/auth/social/google/', credentials);
};

// Refresh JWT token
export const refreshToken = (refreshToken) => {
  return postApi('/auth/jwt/token/refresh/', { refresh: refreshToken });
};

// User logout
export const logoutUser = () => {
  return postApi('/auth/logout/');
};

// Get user details
export const getUserDetails = () => {
  const token = Cookies.get('token');
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };
  return getApi('/auth/user/', config);
}